import styled from "styled-components";

const LoginWrapper = styled.div`
    width: 250px;
`;

export default LoginWrapper;
